// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__yaDCG","content":"LayoutSettings_content__2Lpn8"};